/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleFilterRequest
 */
export interface RoleFilterRequest {
    /**
     * 
     * @type {boolean}
     * @memberof RoleFilterRequest
     */
    includeGlobalValues?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleFilterRequest
     */
    roleIds?: Array<any> | null;
}

/**
 * Check if a given object implements the RoleFilterRequest interface.
 */
export function instanceOfRoleFilterRequest(value: object): value is RoleFilterRequest {
    return true;
}

export function RoleFilterRequestFromJSON(json: any): RoleFilterRequest {
    return RoleFilterRequestFromJSONTyped(json, false);
}

export function RoleFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleFilterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'includeGlobalValues': json['includeGlobalValues'] == null ? undefined : json['includeGlobalValues'],
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
    };
}

export function RoleFilterRequestToJSON(json: any): RoleFilterRequest {
    return RoleFilterRequestToJSONTyped(json, false);
}

export function RoleFilterRequestToJSONTyped(value?: RoleFilterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'includeGlobalValues': value['includeGlobalValues'],
        'roleIds': value['roleIds'],
    };
}

